<template>
  <div class="progress-bar">
    <img :src="src" />
  </div>
</template>
<script>
export default {
  name: 'progress-bar',
  props: {
    src: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="sass" scoped>
.progress-bar
  position: absolute
  background-color: transparent
</style>
